import { handleChangeCheck, handleDisabledCheckbox } from 'Helpers/SettingsHelper'
import { Question } from 'Slices/Settings/SettingsSlice'
import { Checkbox } from 'antd'
import { useAppDispatch, useAppSelector } from 'hooks'
interface StandardCheckboxProps {
  storedValue: any
  storeValue: Function
  userCanEdit: boolean
  question: Question
  respondingEntityId: string
}

function StandardCheckbox(props: StandardCheckboxProps) {
  const dispatch = useAppDispatch()
  const isTrueSet = /^true$/i.test(props.storedValue)
  const editedAnswers = useAppSelector(state => state.present.settings.editedAnswers[props.question.settingsName])
  const answers = useAppSelector(state => state.present.settings.answers[props.question.settingsName])

  return (
    <Checkbox
      checked={isTrueSet}
      onChange={event => {
        handleChangeCheck(
          JSON.stringify(event.target.checked),
          props.question,
          dispatch,
          props.storeValue,
          props.respondingEntityId,
        )
      }}
      disabled={handleDisabledCheckbox(
        props.question,
        props.userCanEdit,
        editedAnswers,
        props.respondingEntityId,
        answers,
      )}
    />
  )
}

export default StandardCheckbox
